import { makeStyles } from "@material-ui/core";

export const useStyles = (styles, props = {}) => makeStyles(styles)(props);

export default useStyles;
